import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "school-information",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "school-information" */ "AdminSettings/routes/SchoolInformationWrapper/routes/SchoolInformation/components"
      ),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        throw err;
      })
  ),
  childRoutes: [],
});
